import type { Plant } from '@/data/plants';

let _communityPlantsCache: Plant[] | null = null;

export function primeCommunityPlants(plants: Plant[]): void {
  _communityPlantsCache = plants;
}

export function clearCommunityPlantsCache(): void {
  _communityPlantsCache = null;
}

export async function getCommunityPlants(): Promise<Plant[]> {
  if (_communityPlantsCache) return _communityPlantsCache;

  try {
    const res = await fetch('/api/community-plants', { cache: 'no-store' });
    if (!res.ok) return [];
    const data = await res.json() as { plants?: Plant[] };
    const plants = Array.isArray(data.plants) ? data.plants : [];
    _communityPlantsCache = plants;
    return plants;
  } catch {
    return [];
  }
}

export async function getCommunityPlantById(id: string): Promise<Plant | null> {
  const plants = await getCommunityPlants();
  return plants.find(plant => plant.id === id) ?? null;
}

export async function searchCommunityPlants(query: string): Promise<Plant[]> {
  const plants = await getCommunityPlants();
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) return plants;

  return plants.filter(plant =>
    plant.name.toLowerCase().includes(normalizedQuery) ||
    plant.type.toLowerCase().includes(normalizedQuery),
  );
}
